<mat-form-field
  class="select-search-dropdown-container"
  [ngClass]="{useCustomToggler: useCustomToggler}"
  [class.mb-1]="itemsFormCtrl?.invalid && itemsFormCtrl?.touched || hints?.children.length > 0"
  [appearance]="useCustomToggler ? 'legacy' : 'outline'"
  #matFormField
>
  <div class="select-trigger-container d-flex ai-center" *ngIf="useCustomToggler">
    <span class="icon icon-filter" [class.active]="itemsFormCtrl.value?.length"></span>
    <span
      *ngIf="itemsFormCtrl.value?.length > 0"
      (click)="removeAllSelectedItems($event)"
      [attr.data-test-id]="[testId, 'remove_selected_items'].join('_')"
      class="filtered row ai-center remove-all-button remove-selected-items"
    >
      <span class="fs-xs item">{{ itemsFormCtrl.value?.length }}</span>
      <span class="icon icon-close"></span>
    </span>
  </div>

  <label class="mb-1 color-navi fs-sm medium" *ngIf="!useCustomToggler && label">
    <span>{{ label }}</span><span
      *ngIf="isRequired" class="color-error"
    >*</span>:
  </label>

  <ng-container *ngIf="!useCustomToggler">
    <button
      class="rst-button"
      *ngIf="itemsFormCtrl?.value != null && select.triggerValue && canReset"
      [class.rst-button--disabled]="itemsFormCtrl?.disabled"
      (click.stop-propagation)="reset()"
      mat-icon-button
      type="button"
      aria-label="Clear element"
      [attr.data-test-id]="['clear_button', testId].join('_')"
      [disabled]="itemsFormCtrl?.disabled"
    >
      <mat-icon [inline]="true">close</mat-icon>
    </button>
  </ng-container>
  <mat-select
    #select
    [formControl]="itemsFormCtrl"
    class="select-search-dropdown-select"
    [class.has-value]="itemsFormCtrl?.value != null && select?.triggerValue"
    [class.cannot-reset]="!canReset"
    [panelClass]="{
      'select-search-dropdown-panel': true,
      'disable-option-centering': disableOptionCentering
    }"
    [class.disable-option-centering]="disableOptionCentering"
    [disableOptionCentering]="disableOptionCentering"
    (openedChange)="openedChange($event)"
    [attr.data-test-id]="'select_search_' + testId"
    [multiple]="isMultiple"
    #ItemsAssignSelect="matSelect"
  >
    <mat-option class="select-search-dropdown-input">
      <ngx-mat-select-search
        noEntriesFoundLabel="{{ 'common.label.not-found' | translate }}"
        [formControl]="ItemsFormFilterCtrl"
        [showToggleAllCheckbox]="useSelectAll"
        [toggleAllCheckboxChecked]="value?.length === normalizedItemList?.length"
        [toggleAllCheckboxTooltipMessage]="'common.label.select-all' | translate"
        [toogleAllCheckboxTooltipPosition]="'above'"
        (toggleAll)="toggleSelectAll($event)"
        [placeholderLabel]="'common.label.search' | translate"
      ></ngx-mat-select-search>
    </mat-option>
    <mat-option
      *ngFor="let item of filteredItemsList$ | async; trackBy: itemTrackFn"
      [value]="item.value"
      [class]="item.level != null ? ['level', item.level].join('-') : ''"
      [disabled]="item?.disabled"
    >
      <div [innerHTML]="item.label"></div>
    </mat-option>
  </mat-select>
  <mat-hint #hints>
    <ng-content selector="mat-hint"></ng-content>
  </mat-hint>
  <mat-error>
    <span class="icon icon-error fs-md"></span>
    {{ errorMessage }}
  </mat-error>
</mat-form-field>
